import { useSnapshot } from 'valtio';

import * as authStore from '@cartwhl/common/stores/authStore';
import { getStudioUrl } from '@cartwhl/common/utils/getStudioUrl';
import LazyVideo from '@cartwhl/ui/atoms/LazyVideo';

import GreenLink from 'components/GreenLink';
import SectionHeader from 'components/SectionHeader';
import { CDN } from 'consts';

export default function StudioShowcaseSection() {
  const { authStatus } = useSnapshot(authStore.state);
  const isSignedIn = authStatus === 'user';

  const handleClick = () => {
    if (isSignedIn) {
      window.location.href = getStudioUrl();
    } else {
      window.location.href = '/login';
    }
  };

  return (
    <section className="py-(--vertical-spacing)">
      <div className="container">
        <SectionHeader
          title="Try it in Cartwheel Canvas"
          description="Explore our web-based application Cartwheel Canvas and start creating today."
          maxWidthTitle="100%"
        />

        <div className="bg-gray-15 mt-8 aspect-video overflow-hidden rounded-2xl">
          <LazyVideo
            src={`${CDN}v2_homepage_05_try_it_in_canvas.webm`}
            className="h-full w-full rounded-[inherit]"
            mode="autoplay"
            contained={true}
          />
        </div>

        <div className="mt-8">
          <GreenLink onClick={handleClick}>Try Cartwheel Canvas</GreenLink>
        </div>
      </div>
    </section>
  );
}
